// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfl_a","ReactCrop--disabled":"bfl_b","ReactCrop--circular-crop":"bfl_c"};